import { render, staticRenderFns } from "./ActionMessages.vue?vue&type=template&id=477fd2ef&"
import script from "./ActionMessages.vue?vue&type=script&lang=js&"
export * from "./ActionMessages.vue?vue&type=script&lang=js&"
import style0 from "./ActionMessages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('477fd2ef')) {
      api.createRecord('477fd2ef', component.options)
    } else {
      api.reload('477fd2ef', component.options)
    }
    module.hot.accept("./ActionMessages.vue?vue&type=template&id=477fd2ef&", function () {
      api.rerender('477fd2ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/APIResponse/components/ActionMessages.vue"
export default component.exports